import React, { Component } from 'react';

class StudioTour extends Component {
  render() {
    return (
        <section className="studioTour" id="studiotour">
            <div className="st-container">
                <div className="map-section" >
                    <div className="st-heading-desktop margin-container-sm">
                        <h1>Welcome to the 19th annual Studio Tour</h1>
                        <p>Use the embedded map of the area to locate each studio. Studios may have a single artist or house several artists.</p>
                    </div>
                    {/* <div
                    style={{
                        width: "100%",
                        height: "100%",
                        border: "2px solid gray",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    >
                        Studio Tour Map Coming Soon
                    </div> */}
                    <iframe
                    className="studioTour-map"
                    title="google map with events for studio tour"
                    src="https://www.google.com/maps/d/u/0/embed?mid=1wQ5Ip1mTzsnIawwKtQH330oBQ_eUpmc&ehbc=2E312F&noprof=1"
                    ></iframe>
                </div>
                <div className="brochure-section">
                    <div className="st-heading-mobile margin-container-sm">
                        <h1>Welcome to the 19th annual Studio Tour</h1>
                        <p>Use the embedded map of the area to locate each studio. Studios may have a single artist or house several artists.</p>
                    </div>
                    <div className="margin-container-sm">
                        <div className="brochure-wrapper">
                            <a href="https://talart.org/uploads/studiotour/tal-studio-tour-brochure-mobile-2026.pdf" target="_blank" rel="noreferrer">
                                <img src="https://talart.org/uploads/studiotour/tal-studio-tour-brochure-cover-2026.jpg" alt="studio tour brochure cover" />
                            </a>
                        </div>
                        <a href="https://talart.org/uploads/studiotour/tal-studio-tour-brochure-mobile-2026.pdf" target="_blank" rel="noreferrer">
                            View the 2026 Studio Tour Brochure
                        </a>
                    </div>
                </div>
            </div>
            <div className="st-printable-map margin-container-sm">
                <h2 className="h2">Printable Map</h2>
                <a href="https://talart.org/uploads/studiotour/tal-studio-tour-printable-map-2026.pdf" target="_blank" rel="noreferrer">
                    <img src="https://talart.org/uploads/studiotour/tal-studio-tour-printable-map-cover-2026.jpg" alt="studio tour brochure cover" />
                    Open the 2026 Printable Map
                </a>
            </div>
            <div className="st-artists margin-container-sm">
                <h2 className="h2">Artists</h2>
                <img src="https://talart.org/uploads/studiotour/tal-studio-tour-locations-artists-2026.png" alt="studio tour locations list" />
            </div>
            <div className="location-section margin-container-sm">
                <h2 className="h2">Locations</h2>
                <img src="https://talart.org/uploads/studiotour/tal-studio-tour-locations-2026.png" alt="studio tour locations list" />
            </div>
        </section>
    );
  }
}

export default StudioTour;